/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47881Req {
  
  /** 项目编号 */
  projectNo?: string;
    
  /** 项目计划编号、里程牌编号 */
  planNo?: string;
    
};



export interface API47881Res {
  /** 任务总数  */
  totalCount?: number;
  /** 已完成任务数量  */
  finishedCount?: number;
  /** 待处理任务数量  */
  waitProcessCount?: number;
  /** 处理中的任务数量  */
  processingCount?: number;
  /** 已逾期的任务数量  */
  overdueCount?: number;
  /** 完成率  */
  finishedRate?: number;
  /**   */
  finishedRateDou?: number;
  /** 逾期率  */
  overdueRate?: number;
  /**   */
  overdueRateDou?: number;
  
};


// 47881 任务统计

export interface IUseGetAPI47881Return {
  /** 任务统计: 接口请求状态 */
  isAPI47881Loading: boolean;
  /** 任务统计: 接口请求返回数据 */
  dataAPI47881: API47881Res;
  /**  任务统计: 接口数据请求方法 */
  fetchAPI47881Data:  (inputs: API47881Req, config?: YWRequestConfig) => Promise<API47881Res>;
  /** 任务统计: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47881 = ():IUseGetAPI47881Return => {
  let isMount = true;
  const [isAPI47881Loading, setIsAPI47881Loading] = useState(false);
  const [dataAPI47881, setDataAPI47881] = useState<API47881Res>({} as API47881Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/statistic`;

  const fetchAPI47881Data = async (inputs: API47881Req, config?: YWRequestConfig): Promise<API47881Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47881Req>) || {}) as API47881Req;
    
  
    if ( isMount ) {
      setIsAPI47881Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47881Res>(`${basePath}/corp-admin/project/plan/task/statistic?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47881(res || {} as API47881Res);
        setIsAPI47881Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47881Loading(false);
      }
      return false as unknown as API47881Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47881Loading,
    dataAPI47881,
    fetchAPI47881Data,
    requestUrl,
  }
}

